// These values correspond to the Sass color variables.
// Custom Sass variables are set in _colors.scss.
// Default Sass variables are here: https://bulma.io/documentation/overview/variables/

export default Object.freeze({
  TURQUIOISE: '#00a88e',
  BLUE: '#13589c',
  PINK: '#f28cb1',
  YELLOW: '#ffd700',
  WHITE: '#fff',
  BLACK: '#000',
  ORANGE: '#cf5d10'
})
